import { useGlobalCache } from 'client/utils/useGlobalCache';
import { useEditor } from 'client/widget-components';
import { useEffect, useState } from 'react';
import { CatalogOption } from './types';
import { getCollectionAPI } from 'client/widgets/runtime-collection-search/collectionService';

const storeDataKey = "catalog_option";

const fetchCatalogOptions = async () => {
    const api = await getCollectionAPI();
    if (!api) {
        return null;
    }
    const storeOptionsData = await api.storeData(storeDataKey).get();
    return (storeOptionsData as unknown as { results: Array<CatalogOption> }).results;
}

const useCatalogOptions = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [optionsMap, setOptionsMap] = useState<Map<string, CatalogOption>>(new Map<string, CatalogOption>());
    const globalCache = useGlobalCache();
    const { isInPreviewOrEditor } = useEditor();

    useEffect(() => {
        const queryKey = [storeDataKey];
        const cachedResult =
            globalCache.get<Map<string, CatalogOption>>(queryKey);

        if (cachedResult) {
            setOptionsMap(cachedResult);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);

        fetchCatalogOptions().then((options) => {
            const map = new Map<string, CatalogOption>();
            options?.forEach(option => {
                map.set(option.name.toLowerCase(), option);
            });

            // only cache in runtime
            if (!isInPreviewOrEditor()) {
                globalCache.set(queryKey, map);
            }

            setOptionsMap(map);
            setIsLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const getOptionsByName = (name: string) => optionsMap.get(name.toLowerCase())

    return { optionsMap, isLoading, getOptionsByName };
};

export default useCatalogOptions;